import { Grid, Stack } from "@mui/material";
import React, { useEffect } from "react";
import GeneralTable from "../../Components/View/Table/TableGeneral";
import { BacklogTableTitle, DamaNoteTitle, TabMainTitle } from "../../Components/View/Typography/title";
import { DamaNotetext } from "../../Components/View/Typography/paragraph";
import EoiDataBlock from "../../Components/View/General/EoiDataBlock";
import useFetch from "../../Service/Hooks/useFetch";
import { ApiUrls } from "../../Components/Utils/globalVariables";

export default function BacklogResult({ code }) {

    const [{response, isLoading, error}, doFetch] = useFetch(ApiUrls.Getbacklogs, "get", true)

    useEffect(() => {
        doFetch({id: code})
    }, [])

    if(isLoading) {
        return (
            <Stack spacing={4}>
                
                <Stack spacing={3}>
                    
                    <Grid container columnSpacing={2} rowSpacing={2} >
                        {response.map((val, i) => {
                            return (
                                <EoiDataBlock key={i} data={val} />
                            )
                        })}
                    </Grid>
                </Stack>
            </Stack>
        )
    }
}
